/* ==========================================================================
   Master Lock Elite landing page
   Gallery, variant picker, sticky add-to-cart bar.
   Vanilla JS, one instance per section, safe to run before/after theme.js.
   ========================================================================== */
(function () {
  'use strict';

  function MLElite(root) {
    this.root = root;
    this.idInput = root.querySelector('[data-ml-variant-id]');
    this.stage = root.querySelector('[data-ml-stage]');
    this.thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-ml-thumb]'));
    this.slides = Array.prototype.slice.call(root.querySelectorAll('[data-ml-slide]'));
    this.options = Array.prototype.slice.call(root.querySelectorAll('[data-ml-variant]'));
    this.rows = Array.prototype.slice.call(root.querySelectorAll('[data-ml-row]'));
    this.sticky = root.querySelector('[data-ml-sticky]');
    this.atc = root.querySelector('[data-ml-atc]');

    this.bindGallery();
    this.bindVariants();
    this.bindProxies();
    this.bindSticky();
  }

  /* --- gallery ----------------------------------------------------------- */

  MLElite.prototype.bindGallery = function () {
    var self = this;
    this.thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        self.showMedia(thumb.getAttribute('data-ml-thumb'));
      });
    });
  };

  // Stops playback in whichever slide is leaving, so audio never continues
  // behind the newly selected media.
  MLElite.prototype.pauseSlide = function (slide) {
    var video = slide.querySelector('video');
    if (video && typeof video.pause === 'function') video.pause();

    var frame = slide.querySelector('iframe');
    // Re-assigning src is the only way to stop a third-party embed we do not control.
    if (frame && frame.src) frame.src = frame.src;
  };

  MLElite.prototype.showMedia = function (mediaId) {
    if (!mediaId) return;
    var self = this;

    this.slides.forEach(function (slide) {
      var active = slide.getAttribute('data-ml-slide') === String(mediaId);
      if (!active && slide.classList.contains('is-active')) self.pauseSlide(slide);
      slide.classList.toggle('is-active', active);
    });

    this.thumbs.forEach(function (thumb) {
      var active = thumb.getAttribute('data-ml-thumb') === String(mediaId);
      thumb.setAttribute('aria-current', active ? 'true' : 'false');
    });
  };

  /* --- variants ---------------------------------------------------------- */

  MLElite.prototype.bindVariants = function () {
    var self = this;
    this.options.forEach(function (option) {
      option.addEventListener('click', function () {
        self.selectVariant(option);
      });
    });
  };

  MLElite.prototype.selectVariant = function (option) {
    var data = option.dataset;
    var id = data.mlVariant;
    var available = data.available === 'true';

    this.options.forEach(function (other) {
      other.setAttribute('aria-pressed', other === option ? 'true' : 'false');
    });

    this.rows.forEach(function (row) {
      row.classList.toggle('is-selected', row.getAttribute('data-ml-row') === id);
    });

    if (this.idInput) this.idInput.value = id;

    this.setText('[data-ml-price]', data.price);
    this.setText('[data-ml-compare]', data.compare);
    this.setText('[data-ml-save]', data.save);
    this.setText('[data-ml-sku]', data.sku);
    this.setText('[data-ml-selected-label]', data.label);
    this.setText('[data-ml-stock-text]', data.stock);

    this.toggle('[data-ml-compare]', !data.compare);
    this.toggle('[data-ml-save]', !data.save);
    this.toggle('[data-ml-sku-row]', !data.sku);

    this.root.querySelectorAll('[data-ml-price]').forEach(function (node) {
      node.classList.toggle('is-sale', !!data.compare);
    });
    this.root.querySelectorAll('[data-ml-stock]').forEach(function (node) {
      node.classList.toggle('ml-stock--out', !available);
    });
    this.root.querySelectorAll('[data-ml-atc], [data-ml-atc-proxy]').forEach(function (button) {
      button.disabled = !available;
      var label = available ? button.getAttribute('data-label-add') : button.getAttribute('data-label-out');
      if (label) button.textContent = label;
    });

    if (data.mediaId) this.showMedia(data.mediaId);
    this.updateUrl(id);
  };

  MLElite.prototype.setText = function (selector, value) {
    this.root.querySelectorAll(selector).forEach(function (node) {
      node.textContent = value || '';
    });
  };

  MLElite.prototype.toggle = function (selector, hide) {
    this.root.querySelectorAll(selector).forEach(function (node) {
      node.hidden = !!hide;
    });
  };

  // Keeps the address bar shareable without adding a history entry per click.
  MLElite.prototype.updateUrl = function (id) {
    if (!window.history || !window.history.replaceState || !window.URL) return;
    try {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', id);
      window.history.replaceState({}, '', url.toString());
    } catch (e) {
      /* older browsers simply keep the current URL */
    }
  };

  /* --- sticky bar -------------------------------------------------------- */

  MLElite.prototype.bindProxies = function () {
    var self = this;
    this.root.querySelectorAll('[data-ml-atc-proxy]').forEach(function (button) {
      button.addEventListener('click', function (event) {
        event.preventDefault();
        // Route through the real button so the theme's ajax cart handler runs once.
        if (self.atc) self.atc.click();
      });
    });
  };

  MLElite.prototype.bindSticky = function () {
    if (!this.sticky) return;
    var anchor = this.root.querySelector('[data-ml-sticky-anchor]');
    if (!anchor) return;
    var bar = this.sticky;

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          // Show the bar only once the in-page add-to-cart has scrolled past.
          var passed = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          bar.classList.toggle('is-visible', passed);
        });
      }, { rootMargin: '0px', threshold: 0 }).observe(anchor);
      return;
    }

    var onScroll = function () {
      bar.classList.toggle('is-visible', anchor.getBoundingClientRect().bottom < 0);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  };

  /* --- boot -------------------------------------------------------------- */

  function init(scope) {
    (scope || document).querySelectorAll('[data-ml-elite]').forEach(function (root) {
      if (root.dataset.mlReady) return;
      root.dataset.mlReady = 'true';
      new MLElite(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  // Theme editor: re-bind when the section is re-rendered.
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
